import { createContext, useContext } from 'react';
import { RealtimeStore, realtimeStore } from './realtimeStore';

// Store container
export interface RootStore {
  realtimeStore: RealtimeStore;
}

export const rootStore: RootStore = {
  realtimeStore,
};

// React Context
export const StoreContext = createContext<RootStore>(rootStore);

// Hook for accessing stores
export function useStores(): RootStore {
  return useContext(StoreContext);
}

// Convenience hooks for individual stores
export function useRealtimeStore(): RealtimeStore {
  const { realtimeStore } = useStores();
  return realtimeStore;
}

// Re-export types
export type { RealtimeStore, ConnectionStatus } from './realtimeStore';
export type {
  OrderEvent,
  OrderEventData,
  OrderDispatchedData,
  OrderStatusUpdateData,
  DriverLocationData,
  RealtimeEvent,
} from '@vn-propane/shared/client';
